import React from 'react';
import cn from 'classnames';
import styles from './Insight.module.scss';

export default function Insight(props) {
  return (
    <React.Fragment>
      <div className={cn(styles.root, 'insight')}>
        <div className={styles.flex_col}>
          <h1 className={styles.title}>My Profile Insights </h1>

          <div className={styles.content_box}>
            <div className={styles.flex_row}>
              <div className={styles.flex_row__cell}>
                <div className={styles.flex_row1}>
                  <div className={styles.flex_row1__cell}>
                    <img
                      src={require('assets/ba21be37592a07cfca64a0a1a4b8801c.png')}
                      alt="alt text"
                      className={styles.icon}
                    />
                  </div>
                  <div className={styles.flex_row1__cell1}>
                    <div className={styles.flex_col1}>
                      <h5 className={styles.highlights}>Visits</h5>
                      <h1 className={styles.title1}>2,765</h1>

                      <div className={styles.flex_row2}>
                        <div className={styles.flex_row2__cell}>
                          <img
                            src={require('assets/2b7977da3543445cf94420cc9aa4fc3c.png')}
                            alt="alt text"
                            className={styles.image}
                          />
                        </div>
                        <div className={styles.flex_row2__cell1}>
                          <h5 className={styles.highlights2}>%10</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.flex_row__spacer} />
              <div className={styles.flex_row__cell1}>
                <div className={styles.rect4} />
              </div>
              <div className={styles.flex_row__spacer1} />
              <div className={styles.flex_row__cell2}>
                <div className={styles.flex_row1}>
                  <div className={styles.flex_row1__cell2}>
                    <img
                      src={require('assets/907271977525cdac69d13c133b4beaa7.png')}
                      alt="alt text"
                      className={styles.icon}
                    />
                  </div>
                  <div className={styles.flex_row1__cell3}>
                    <div className={styles.flex_col1}>
                      <h5 className={styles.highlights1}>New</h5>
                      <h1 className={styles.title1}>253</h1>

                      <div className={styles.flex_row2}>
                        <div className={styles.flex_row2__cell2}>
                          <img
                            src={require('assets/1649bdca12d09516035c7ed9ac8c96be.png')}
                            alt="alt text"
                            className={styles.image}
                          />
                        </div>
                        <div className={styles.flex_row2__cell3}>
                          <h5 className={styles.highlights3}>%10</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.flex_row__spacer2} />
              <div className={styles.flex_row__cell1}>
                <div className={styles.rect4} />
              </div>
              <div className={styles.flex_row__spacer3} />
              <div className={styles.flex_row__cell3}>
                <div className={styles.flex_row3}>
                  <div className={styles.flex_row3__cell}>
                    <img
                      src={require('assets/53e3cc4aea7f72eaabbbe94490b47538.png')}
                      alt="alt text"
                      className={styles.icon}
                    />
                  </div>
                  <div className={styles.flex_row3__cell1}>
                    <div className={styles.flex_col1}>
                      <h5 className={styles.highlights4}>Average</h5>
                      <h1 className={styles.title1}>896</h1>

                      <div className={styles.flex_row2}>
                        <div className={styles.flex_row2__cell4}>
                          <img
                            src={require('assets/2b7977da3543445cf94420cc9aa4fc3c.png')}
                            alt="alt text"
                            className={styles.icon1}
                          />
                        </div>
                        <div className={styles.flex_row2__cell5}>
                          <h5 className={styles.highlights2}>%10</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.flex_row__spacer4} />
              <div className={styles.flex_row__cell4}>
                <div className={styles.rect5} />
              </div>
              <div className={styles.flex_row__spacer1} />
              <div className={styles.flex_row__cell3}>
                <div className={styles.flex_row3}>
                  <div className={styles.flex_row3__cell2}>
                    <img
                      src={require('assets/0a673439fa48787f06fdea9877202a39.png')}
                      alt="alt text"
                      className={styles.icon}
                    />
                  </div>
                  <div className={styles.flex_row3__cell3}>
                    <div className={styles.flex_col1}>
                      <h5 className={styles.highlights5}>Total</h5>
                      <h1 className={styles.title1}>253</h1>

                      <div className={styles.flex_row2}>
                        <div className={styles.flex_row2__cell6}>
                          <img
                            src={require('assets/1649bdca12d09516035c7ed9ac8c96be.png')}
                            alt="alt text"
                            className={styles.icon1}
                          />
                        </div>
                        <div className={styles.flex_row2__cell7}>
                          <h5 className={styles.highlights31}>%10</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.flex_row4}>
            <div className={styles.flex_row4__cell}>
              <div
                style={{ '--src': `url(${require('assets/2a0bbfdc0a9d872217d64c0eddb8bd67.png')})` }}
                className={styles.image2}
              />
            </div>
            <div className={styles.flex_row4__spacer} />
            <div className={styles.flex_row4__cell1}>
              <div className={styles.content_box1}>
                <div className={styles.flex_col2}>
                  <h3 className={styles.subtitle}>Details</h3>

                  <div className={styles.grid}>
                    <div className={styles.grid__cell}>
                      <h5 className={styles.highlights6}>Previous Day</h5>
                    </div>
                    <div className={styles.grid__cell}>
                      <h5 className={styles.highlights11}>4,324.32</h5>
                    </div>
                    <div className={styles.grid__cell}>
                      <h5 className={styles.highlights6}>Visits to date</h5>
                    </div>
                    <div className={styles.grid__cell}>
                      <h5 className={styles.highlights11}>4,834.32 - 4,932.53</h5>
                    </div>
                    <div className={styles.grid__cell}>
                      <h5 className={styles.highlights6}>Daily record</h5>
                    </div>
                    <div className={styles.grid__cell}>
                      <h5 className={styles.highlights11}>2,623.28 - 3,823.74</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.flex_col__cell}>
            <img
              src={require('assets/089065c0562453a41a6b7aabe9faae1d.png')}
              alt="alt text"
              className={styles.image1}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
